import { Directive, HostBinding, Input } from '@angular/core';

@Directive()
export abstract class AbstractAttendanceTimelineDirective {
  @Input() sessionStart: Date;
  @Input() sessionEnd: Date;

  @HostBinding('style.left') get percentage(): string {
    const startTime = new Date(this.sessionStart).getTime();
    const endTime = new Date(this.sessionEnd).getTime();
    const itemTime = this.getItemTimestamp();
    const p = (itemTime - startTime) / (endTime - startTime);

    return p * 100 + '%';
  }

  /**
   * Abstract method that child components must implement
   * to provide the timestamp for their specific item type
   */
  protected abstract getItemTimestamp(): number;
}
